var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortZaAlphaIcon = function SvgSortZaAlphaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      fill: "none"
    },
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SortZAAlphaIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#SortZAAlphaIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.318 18.818H4L6.008 13h1.586l2.005 5.818H8.281L6.824 14.33h-.046zm-.082-2.287h3.113v.96H5.236zm-.23-5.713v-.73l2.903-4.074H5V5h4.455v.73L6.547 9.804H9.46v1.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.32 6a.68.68 0 0 1 .68-.68h6.375a.68.68 0 0 1 0 1.36H13a.68.68 0 0 1-.68-.68m0 5.833a.68.68 0 0 1 .68-.68h4.125a.68.68 0 0 1 0 1.36H13a.68.68 0 0 1-.68-.68m0 5.834a.68.68 0 0 1 .68-.68h1.875a.68.68 0 0 1 0 1.36H13a.68.68 0 0 1-.68-.68"
  }))));
};
export default SvgSortZaAlphaIcon;